package pl.decks.personal.components.widgets.hasdiagram

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.silk.style.CssStyleVariant

class HASLineScope {
    var fraction: Float = 1f
    var visible: Boolean = true
    var modifier: Modifier = Modifier
    var variant: CssStyleVariant<HASDiagramStylesheet.ConnectionLines.Kind>? = null
    var direction: HASLineDirection? = null

    internal fun merge(other: HASLineScope): HASLineScope = HASLineScope().also {
        it.fraction = other.fraction
        it.visible = other.visible
        it.modifier = this.modifier.then(other.modifier)
        it.direction = other.direction
        it.variant = other.variant ?: this.variant
    }
}
